import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Product from "../../../domains/Products/Product";

interface ProductsState {
  products: Product[]
  areProductsLoading: boolean
  hasErrorLoadingProducts: boolean
}

export const SLICE_NAME = "products";

const initialState: ProductsState = {
  products: [],
  areProductsLoading: false,
  hasErrorLoadingProducts: false,
};

export const productsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getProducts: state => {
      state.areProductsLoading = true;
    },
    getProductsSuccess: (state, action: PayloadAction<Product[]>) => {
      state.products = [...action.payload];
      state.areProductsLoading = false;
    },
    getProductsError: state => {
      state.hasErrorLoadingProducts = true;
      state.areProductsLoading = false;
    },
  },
});

export const { getProducts, getProductsSuccess, getProductsError } = productsSlice.actions;

export default productsSlice.reducer;

